import { render, staticRenderFns } from "./supplyAgreeList.vue?vue&type=template&id=644fea3e&scoped=true&"
import script from "./supplyAgreeList.vue?vue&type=script&lang=js&"
export * from "./supplyAgreeList.vue?vue&type=script&lang=js&"
import style0 from "./supplyAgreeList.vue?vue&type=style&index=0&id=644fea3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644fea3e",
  null
  
)

export default component.exports